import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const XlargeRectangleIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.59998 3.6C3.59998 2.96348 3.85283 2.35303 4.30292 1.90294C4.75301 1.45285 5.36346 1.2 5.99998 1.2H18C18.6365 1.2 19.2469 1.45285 19.697 1.90294C20.1471 2.35303 20.4 2.96348 20.4 3.6V20.4C20.4 21.0365 20.1471 21.647 19.697 22.0971C19.2469 22.5471 18.6365 22.8 18 22.8H5.99998C5.36346 22.8 4.75301 22.5471 4.30292 22.0971C3.85283 21.647 3.59998 21.0365 3.59998 20.4V3.6Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

XlargeRectangleIcon.displayName = 'XlargeRectangleIcon';
